// Remotely managed pop-up cards (popup.cards key in site_copy_overrides).

export interface PopupCard {
  id: string;
  title: string;
  price: string;
  bullets: string[];
  image: string;
}

function isHttps(url: unknown): url is string {
  return typeof url === "string" && /^https:\/\//i.test(url.trim());
}

// Returns [] when the value is empty, invalid JSON, or has no usable entries.
export function parsePopupCards(raw: string): PopupCard[] {
  const text = (raw || "").trim();
  if (!text) return [];
  let parsed: unknown;
  try {
    parsed = JSON.parse(text);
  } catch {
    return [];
  }
  if (!Array.isArray(parsed)) return [];

  const cards: PopupCard[] = [];
  parsed.forEach((entry, i) => {
    if (!entry || typeof entry !== "object" || Array.isArray(entry)) return;
    const e = entry as Record<string, unknown>;
    const title = typeof e.title === "string" ? e.title.trim() : "";
    if (!title) return;
    const bullets = Array.isArray(e.bullets)
      ? e.bullets.filter((b): b is string => typeof b === "string" && b.trim().length > 0).map((b) => b.trim())
      : [];
    cards.push({
      id: typeof e.id === "string" && e.id.trim() ? e.id.trim() : `card-${i}`,
      title,
      price: typeof e.price === "string" ? e.price.trim() : "",
      bullets,
      image: isHttps(e.image) ? (e.image as string).trim() : "",
    });
  });
  return cards;
}
